import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
const images = ["https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/87a90590-97e8-413a-8d8a-a4828893aa8c/SHOT_1-8.jpg", "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/3652dc0c-c8f7-46d3-893b-c8cc806dd49a/SHOT_1-38.jpg", "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/files/a80cc67a-e564-49c3-a92f-1aa1dcffcd5d/SHOT_1-64.jpg"];
export const StorySection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(current => (current + 1) % images.length);
  };
  const previous = () => {
    setCurrentIndex(current => (current - 1 + images.length) % images.length);
  };
  return <section id="story" className="relative w-full bg-neutral-950/50 backdrop-blur-sm py-16 md:py-24" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-76">
        <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-start" data-id="element-77">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="space-y-4 md:space-y-6" data-id="element-78">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center md:text-left" data-id="element-79">
              My Story
            </h2>
            <div className="space-y-3 text-sm sm:text-base md:text-lg text-white/80" data-id="element-80">
              <p data-id="element-81">
                I was born in the pulsing heart of New York, a city that taught
                me to dream big from the moment I could breathe. As a teenager,
                life carried me to the sunlit shores of Florida—a new chapter, a
                fresh canvas. I didn't finish high school, no diploma to frame
                and hang, but I refused to see it as a loss.
              </p>
              <p data-id="element-82">
                I'll never forget the early days—scraping by, then hitting six
                figures in a year. It felt like a win, like I'd arrived. But
                then came the moment that shattered every limit I'd ever known:
                earning multiple six figures in a single month. That wasn't just
                money—it was a wake-up call. It hit me like a tidal wave:
                anything is possible, with God on my side. Everything I'd been
                told about ceilings, about "can't," crumbled. Life wasn't about
                playing small—it was about daring to dream bigger than the
                doubts.
              </p>
              <p data-id="element-83">
                I built my own empire of knowledge, surrounding myself with
                successful businessmen who took me under their wings. My
                mentors—titans of industry—didn't hand me a textbook; they
                handed me a torch, igniting lessons of grit, vision, and
                fearless ambition. With their wisdom as my fuel, I threw myself
                into the fire of opportunity. Step by step, I became part of
                creating over $200 million dollars in value—proof that grit
                outshines grades every time.
              </p>
              <p data-id="element-84">
                Every step I've taken since has been a defiance of the odds,
                every triumph a brick in a legacy I've built with God's help.
                I've learned that the truest education comes not from walls of
                ivy, but from the fire of struggle, the will to overcome, and
                finally from finding your purpose with clarity. I am Elliot
                Martinez—a man who turned humble beginnings into a blazing
                testament of what's possible when you dare to chase the
                impossible.
              </p>
              <p data-id="element-85">
                My journey isn't just mine—it's a mirror for anyone who's ever
                felt stuck, overlooked, or underestimated. it's a call to every
                soul out there fighting to be seen. If I can turn a "no" into a
                legacy, so can you. The only limit is the one you let stand. I'm
                living proof that greatness isn't given—it's claimed by those
                bold enough to believe that the only ceiling is the one you
                refuse to break.
              </p>
            </div>
          </motion.div>
          <div className="relative mt-8 md:mt-0" data-id="element-86">
            <div className="relative aspect-[3/4] w-full max-w-[500px] mx-auto" data-id="element-87">
              <AnimatePresence mode="wait" data-id="element-88">
                <motion.img key={currentIndex} src={images[currentIndex]} alt={`Story image ${currentIndex + 1}`} className="absolute inset-0 w-full h-full object-cover rounded-xl shadow-2xl" initial={{
                opacity: 0,
                scale: 0.9
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 1.1
              }} transition={{
                duration: 0.5
              }} data-id="element-89" />
              </AnimatePresence>
              <div className="absolute inset-y-0 left-0 right-0 flex items-center justify-between z-10" data-id="element-90">
                <button onClick={previous} className="transform -translate-x-6 p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Previous image" data-id="element-91">
                  <ChevronLeft className="w-6 h-6 text-white" data-id="element-92" />
                </button>
                <button onClick={next} className="transform translate-x-6 p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors" aria-label="Next image" data-id="element-93">
                  <ChevronRight className="w-6 h-6 text-white" data-id="element-94" />
                </button>
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-4" data-id="element-95">
              {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-colors ${index === currentIndex ? "bg-white" : "bg-white/30"}`} aria-label={`Go to image ${index + 1}`} data-id="element-96" />)}
            </div>
          </div>
        </div>
      </div>
    </section>;
};